module.exports = __webpack_public_path__ + "static/media/thumb_artificialcity_503x503.e608da27.jpg";